export default {
  getSalesOrder: (state) => state.salesOrder,
};
